// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"98e36bc2","129":"9ba68584","180":"01390588","245":"ade18a4d","270":"9857415e","331":"7ffe3e75","515":"56228744","545":"ae71c03d","639":"565b0294","731":"1da37648","735":"7b43095e","784":"5a838aa0","815":"27ae390b","818":"4a72e558"}[chunkId] + ".chunk.js";
};